import { LRUCache } from 'lru-cache'

const LRUCacheLive = new LRUCache<string, any>({
  max: 500,
  // 1 day
  ttl: 1000 * 60 * 60 * 24,
})

export default LRUCacheLive
